import React, { Fragment, PropsWithChildren, ReactElement } from 'react';

import './modal.scss';

interface Props extends PropsWithChildren<unknown> {
  show: boolean;
}

const Modal = ({ show, children }: Props): ReactElement => {
  if (!show) return <Fragment />;

  return (
    <div className="modal">
      <div className="modal__content">{children}</div>
    </div>
  );
};

export default Modal;
